import { render, staticRenderFns } from "./UserChatCard.vue?vue&type=template&id=50c2d119&scoped=true&"
import script from "./UserChatCard.vue?vue&type=script&lang=js&"
export * from "./UserChatCard.vue?vue&type=script&lang=js&"
import style0 from "./UserChatCard.vue?vue&type=style&index=0&id=50c2d119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2d119",
  null
  
)

export default component.exports